module.exports = __webpack_public_path__ + "img/violet_074.426401f4.png";